exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{font-family:Yanone Kaffeesatz,sans-serif}body{display:flex;flex-direction:column;height:100vh;background-color:rgba(250,255,26,.1)}.wrapper{min-height:100vh;display:grid;grid-template-rows:auto 1fr auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41dbb3f6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 29
// module chunks = 0